import PropTypes from 'prop-types';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ConfigurationChangeModal = ({ show, fromValue, toValue, isDefault, onCancel, onContinue, isLoading }) => {
  if (!show) {
    return null;
  }

  const handleKeepCustomValues = () => {
    onContinue(false);
  };

  const handleOverrideCustomValues = () => {
    onContinue(true);
  };

  const handleContinue = () => {
    onContinue(false);
  };

  return (
    <dialog open={show} className="modal">
      <div className="modal-box">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-yellow-100 p-2 rounded-full">
            <ExclamationTriangleIcon className="w-6 h-6 text-yellow-600" />
          </div>
          <h3 className="font-bold text-lg">Configuration Change</h3>
        </div>
        <p className="py-2">
          You are changing the data configuration from <span className="font-semibold">{fromValue}</span> to{' '}
          <span className="font-semibold">{toValue}</span>.
        </p>
        {isDefault ? (
          <>
            <p className="text-gray-600">This will update all related parameter values with the new configuration.</p>
            <div className="modal-action">
              <button onClick={onCancel} disabled={isLoading} className="btn btn-sm btn-outline">
                Cancel
              </button>
              <button
                onClick={handleContinue}
                disabled={isLoading}
                className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white border-none"
              >
                {isLoading ? <span className="loading loading-spinner loading-sm"></span> : 'Continue'}
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="text-gray-600">You have custom values for some parameters. How would you like to proceed?</p>
            <div className="modal-action flex-col items-center gap-2">
              <div className="flex gap-2 w-full">
                <button
                  onClick={handleKeepCustomValues}
                  disabled={isLoading}
                  className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white border-none flex-1"
                >
                  {isLoading ? <span className="loading loading-spinner loading-sm"></span> : 'Keep Custom Values'}
                </button>
                <button
                  onClick={handleOverrideCustomValues}
                  disabled={isLoading}
                  className="btn btn-sm btn-outline border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white flex-1"
                >
                  Override Custom Values
                </button>
              </div>
              <button onClick={onCancel} disabled={isLoading} className="btn btn-ghost btn-sm text-gray-500">
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
      <div className="modal-backdrop bg-black/50" onClick={!isLoading ? onCancel : undefined}></div>
    </dialog>
  );
};

ConfigurationChangeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  fromValue: PropTypes.string,
  toValue: PropTypes.string,
  isDefault: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ConfigurationChangeModal;
